import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, submit } from 'redux-form/immutable';
import Slider from 'material-ui/Slider';
import Toggle from 'material-ui/Toggle';

import FlatButton from 'material-ui/FlatButton';

import ReduxDialog from '../Common/ReduxDialog';
import { showDialog, hideDialog } from '../../actions/dialogs';
import { getTenantId } from '../../utils/firebase';
import { upgradeTenantRoutine } from '../../routines';

import styles from './styles';

// TODO conslidate into common
const calculateTaskPrice = (count) => {
  const price = (13.438 * (Math.pow(count, -0.7379))) + 0.25;
  return Math.min(price, 1);
};

const RETENTION_MONTHS = [1, 2, 3, 6, 12];
const RETENTION_PRICING = [0,
  5,
  9.5,
  20,
  27.5];

class UpgradeDialog extends React.Component {
  static propTypes = {
    onRequestClose: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    paymentSource: PropTypes.object,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    upgrade: PropTypes.func.isRequired,
    tenant: PropTypes.object.isRequired,
  };

  state = {
    estimatedTasks: 25,
    taskCost: 1,
    retentionPeriodIdx: 0,
    brandedApp: false,
  };

  componentWillMount() {
    const { tenant } = this.props;
    if (tenant.settings && tenant.settings.retentionPeriod) {
      console.log('tenant.settings.retentionPeriod', tenant.settings.retentionPeriod);
      this.setState({
        retentionPeriodIdx: RETENTION_MONTHS.indexOf(tenant.settings.retentionPeriod),
      });
    }
  }

  handleRequestClose = () => {
    if (this.props.onRequestClose) {
      this.props.onRequestClose();
    }

    this.props.hideDialog('upgrade');
  };

  handlePaymentSourceCreated = (token, retentionPeriod, brandedApp) => {
    console.log('handlePaymentSourceCreated', token, retentionPeriod, brandedApp);
    this.props.upgrade({
      tenantId: getTenantId(),
      token,
      retentionPeriod,
    });
  };

  handleUpgrade = () => {
    const { retentionPeriodIdx, brandedApp } = this.state;
    const retentionPeriod = RETENTION_MONTHS[retentionPeriodIdx];
    if (!this.props.paymentSource) {
      this.props.showDialog('creditcard', {
        onRequestClose: ({ token }) => this.handlePaymentSourceCreated(token, retentionPeriod, brandedApp),
        retentionPeriod,
        brandedApp,
      });
    } else {
      this.handlePaymentSourceCreated(null, retentionPeriod, brandedApp);
    }
  };

  handleEstimatedTasksChanged = (evt, estimatedTasks) => {
    this.setState({
      estimatedTasks,
      taskCost: calculateTaskPrice(estimatedTasks),
    });
  };

  handleRetentionPeriodChanged = (evt, retentionPeriodIdx) => {
    this.setState({
      retentionPeriodIdx,
    });
  };

  handleBrandedAppToggled = (evt, brandedApp) => {
    console.log('handleBrandedAppToggled', evt, brandedApp);
    this.setState({
      brandedApp,
    });
  };

  render() {
    const { estimatedTasks, taskCost, retentionPeriodIdx, brandedApp } = this.state;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.handleRequestClose()}
      />,
      <FlatButton
        label="Upgrade"
        primary
        keyboardFocused
        type="submit"
        onClick={this.handleUpgrade}
      />,
    ];

    return (
      <ReduxDialog
        name="upgrade"
        title={'Upgrade'}
        actions={actions}
        onRequestClose={() => this.props.onRequestClose()}
        bodyStyle={styles.body}
      >
        <div style={styles.row}>
          <div style={styles.baseCharge}><h3>Base Charge</h3></div>
          <div style={styles.cost}>$25</div>
        </div>

        <div style={styles.row}>
          <div style={{ flex: 1 }}>
            <h3>Data Retention Period</h3>
            <div style={styles.description}>How long would you like your data kept for?</div>
            <Slider
              min={0}
              max={4}
              step={1}
              style={styles.slider}
              value={retentionPeriodIdx}
              onChange={this.handleRetentionPeriodChanged}
            />
          </div>
          <div style={styles.col}>
            <div style={styles.retentionPeriod}>{ RETENTION_MONTHS[retentionPeriodIdx] } month(s)</div>
            <div style={styles.retentionPeriodCost}>{ retentionPeriodIdx > 0 ?
              <span>${ RETENTION_PRICING[retentionPeriodIdx].toFixed(2) } / month</span> : <span>Included</span> }</div>
          </div>
        </div>

        <div style={styles.row}>
          <div style={{ flex: 1 }}>
            <h3>Estimated Task Usage</h3>
            <div style={styles.description}>The more tasks you create, the cheaper the per task rate becomes. <b>You are
              only billed for the tasks you use</b></div>
            <Slider
              min={25}
              max={1000}
              step={25}
              style={styles.slider}
              value={estimatedTasks}
              onChange={this.handleEstimatedTasksChanged}
            />
          </div>
          <div style={styles.col}>
            <div style={styles.count}>{ estimatedTasks } tasks</div>
            <div
              style={styles.cost}>
              { estimatedTasks > 25 ? `$${Math.round(taskCost * Math.max(0, (estimatedTasks - 25)))}` : 'Included' }
            </div>
          </div>
        </div>

        <div style={styles.row}>
          <Toggle
            label="Branded iOS and Android App"
            style={styles.brandedApp}
            toggled={brandedApp}
            onToggle={this.handleBrandedAppToggled}
          />
        </div>
        { brandedApp ? <div style={styles.brandedAppCost}>$500 / month</div> : null }

        {/*</Paper>*/}
        {/*</form>*/}
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'upgrade',  // a unique identifier for this form
  onSubmit: (values, dispatch, props) => {
    console.log('onSubmit');
  },
})(UpgradeDialog);

function mapStateToProps(state) {
  const paymentSource = state.get('tenants').get('paymentSource');
  return {
    tenant: state.get('tenants').get('tenant').toJS(),
    paymentSource: paymentSource ? paymentSource.toJS() : null,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit: () => submit('upgrade'),
    showDialog,
    hideDialog,
    upgrade: upgradeTenantRoutine.trigger,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/UpgradeDialog/index.js